import { TextField } from '@shared/ui/kit';
import styles from './invite-acceptance-field.module.scss';

interface InviteAcceptanceFieldProps {
  inviteAcceptionInfo: string;
  inviteAcceptionInfoReadOnly?: boolean;
  onInviteAcceptionInfoChange: (value: string) => void;
}

export const InviteAcceptanceField = ({
  inviteAcceptionInfo,
  inviteAcceptionInfoReadOnly = false,
  onInviteAcceptionInfoChange,
}: InviteAcceptanceFieldProps) => (
  <div className={styles.textFieldWrapper}>
    <div className={styles.textFieldHeader}>
      <p className={styles.textFieldLabel}>Текст после принятия приглашения</p>
    </div>
    <TextField
      labelMsg=""
      changeFunction={(event) => onInviteAcceptionInfoChange(event.target.value)}
      placeholder="Введите текст"
      value={inviteAcceptionInfo}
      isDisabled={inviteAcceptionInfoReadOnly}
      settings={{
        width: '100%',
        cursor: 'text',
        resize: 'vertical',
        height: 'auto',
        minHeight: '102px',
        maxHeight: '228px',
        overflow: 'auto',
      }}
    />
  </div>
);
